import store from "@/store"

export default {
  async beforeRouteEnter(to, form, next) {
    const userUuid = store.state.userInfo.userInfo.userUuid
    if (!userUuid) {
      const { isWx, isNfPlus } = store.state.systemInfo
      if (!isWx && !isNfPlus) {
        await store.dispatch("getSystemInfo")
      }
      await store.dispatch("userInfo/getUserInfo")
    }
    next()
  }
}
